import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import SEOHead from "@/components/SEOHead";
import SeoImage from "@/components/SeoImage";
import { breadcrumbJsonLd } from "@/lib/schema";
import { useSiteContent } from "@/lib/siteContent";
import { useI18n } from "@/lib/i18n";

export default function Treatments() {
  const c = useSiteContent("treatments_hero");
  const { t, pick } = useI18n();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/treatments").then((r) => setItems(r.data)); }, []);
  return (
    <section data-testid="treatments-page" className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <SEOHead
        title="Tratamientos: Odontología sin dolor, odontopediatría e higiene oral en Armenia · Katia Falón"
        description="Odontología sin dolor, odontopediatría, higiene oral, estética dental, ortodoncia e implantes en Armenia, Quindío. Planes claros y valoración antes de comenzar."
        path="/tratamientos"
        jsonLd={breadcrumbJsonLd([{name:"Inicio",path:"/"},{name:"Tratamientos",path:"/tratamientos"}])}
      />
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--clinic-muted))]">{pick(c.eyebrow, "treatments.eyebrow")}</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl">
          {pick(c.title, "treatments.title")}
        </h1>
        <p className="mt-6 text-base leading-relaxed text-[hsl(var(--clinic-muted))]">
          {pick(c.body, "treatments.body")}
        </p>
      </div>
      <div className="mt-12 grid gap-6 sm:grid-cols-2">
        {items.map((it) => (
          <Link
            key={it.slug}
            to={`/tratamientos/${it.slug}`}
            data-testid={`treatment-card-${it.slug}`}
            className="group flex flex-col overflow-hidden rounded-2xl border border-[hsl(var(--clinic-border))] bg-white transition-transform hover:-translate-y-1 hover:shadow-lg"
          >
            {it.banner_slug && (
              <div className="aspect-[21/9] w-full overflow-hidden bg-[hsl(var(--clinic-bg))]">
                <SeoImage
                  slug={it.banner_slug}
                  alt={`${it.name} en Katia Falón Odontología, Armenia (Quindío) — ${it.tagline}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  testId={`treatment-banner-${it.slug}`}
                />
              </div>
            )}
            <div className="flex flex-1 flex-col p-8">
              <h2 className="font-display text-3xl">{it.name}</h2>
              <p className="mt-2 text-sm text-[hsl(var(--clinic-muted))]">{it.tagline}</p>
              <p className="mt-4 flex-1 text-sm leading-relaxed">{it.description}</p>
              <div className="mt-6 flex items-center justify-between text-sm">
                <span className="text-[hsl(var(--clinic-muted))]">{it.duration}</span>
                <span className="inline-flex items-center gap-1 font-semibold text-[hsl(var(--clinic-secondary))]">
                  {t("common.reserveNow")} <ArrowRight size={14} />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
